import React, { useState } from 'react';
import authService from '../services/authService';
import Button from './ui/Button';
import './Login.css';
import './AuthPages.css';

/**
 * Página "Redefinir senha" — rota /reset-password?token=XXX.
 *
 * O app não usa React Router: App.jsx detecta o pathname e renderiza
 * esta página. O token vem na query string do link enviado por e-mail.
 *
 * Envia POST /auth/reset-password com { token, nova_senha }.
 * (O campo do backend é `nova_senha` — não `new_password`.)
 */
function getTokenFromUrl() {
  try {
    return new URLSearchParams(window.location.search).get('token') || '';
  } catch (e) {
    return '';
  }
}

function ResetPassword() {
  const [token] = useState(getTokenFromUrl);
  const [senha, setSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (senha.length < 8) {
      setError('A senha deve ter pelo menos 8 caracteres.');
      return;
    }
    if (senha !== confirmacao) {
      setError('As senhas não coincidem.');
      return;
    }

    setLoading(true);
    try {
      await authService.resetPassword(token, senha);
      setDone(true);
      // Redireciona para o login após mostrar o sucesso
      setTimeout(() => { window.location.href = '/'; }, 2500);
    } catch (err) {
      setError(err.message || 'Não foi possível redefinir a senha.');
    } finally {
      setLoading(false);
    }
  };

  // Link sem token → inválido
  if (!token) {
    return (
      <div className="login-page-wrapper">
        <div className="login-form-column auth-card">
          <div className="login-form-header">
            <h2 className="form-title">Link inválido</h2>
            <p className="form-subtitle">
              Este link de redefinição é inválido ou está incompleto.
              Solicite um novo.
            </p>
          </div>
          <div className="auth-back">
            <a href="/forgot-password" className="forgot-link">
              Solicitar novo link
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page-wrapper">
      <div className="login-form-column auth-card">
        <div className="login-form-header">
          <h2 className="form-title">Redefinir senha</h2>
          <p className="form-subtitle">
            Crie uma nova senha para a sua conta. Mínimo de 8 caracteres.
          </p>
        </div>

        {done ? (
          <div className="success-message">
            Senha redefinida com sucesso! Redirecionando para o login...
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="login-form-main">
            <div className="form-group">
              <label className="form-label">Nova senha</label>
              <div className="input-wrapper">
                <span className="material-symbols-outlined input-icon">lock</span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-input"
                  placeholder="••••••••"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  required
                  disabled={loading}
                />
                <button
                  type="button"
                  className="visibility-btn"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <span className="material-symbols-outlined">
                    {showPassword ? 'visibility_off' : 'visibility'}
                  </span>
                </button>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Confirmar nova senha</label>
              <div className="input-wrapper">
                <span className="material-symbols-outlined input-icon">lock</span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-input"
                  placeholder="••••••••"
                  value={confirmacao}
                  onChange={(e) => setConfirmacao(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            <Button type="submit" className="submit-btn" disabled={loading}>
              {loading ? 'REDEFININDO...' : 'REDEFINIR SENHA'}
              <span className="material-symbols-outlined" style={{ marginLeft: '0.5rem' }}>arrow_forward</span>
            </Button>

            <div className="auth-back">
              <a href="/" className="forgot-link">← Voltar ao login</a>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
